export default __webpack_public_path__ + "static/media/Tarim's Twin-axe of Sanctity.bb69db49.jpg";